

const LoadingState = {
    PENDING : 'PENDING',
    FULFILLED: 'FULFILLED',
    FAILED: 'FAILED'
}


export {LoadingState}